// TODO: replace with generated api-client service after client regeneration
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthControllerService } from 'src/app/api-client';
import { resolveApiBasePath } from './api-v2-base.util';

export type ConsoleActivityType =
  | 'TRANSACTION_APPROVED'
  | 'TRANSACTION_PENDING'
  | 'COUPON_REDEEMED'
  | 'MEMBER_JOINED';

export interface ConsoleDashboardSeriesPointDto {
  date: string;
  pointsEarned: number;
  pointsRedeemed: number;
  newMembers: number;
}

export interface ConsoleDashboardActivityDto {
  type: ConsoleActivityType;
  userEmail: string | null;
  points: number | null;
  couponName: string | null;
  loyaltyProgramName: string | null;
  amount: number | null;
  timestamp: string;
}

export interface ConsoleDashboardDto {
  revenue: number;
  revenueDeltaPct: number | null;
  transactionCount: number;
  transactionCountDeltaPct: number | null;
  pointsAwarded: number;
  pointsAwardedDeltaPct: number | null;
  couponsRedeemed: number;
  couponsRedeemedDeltaPct: number | null;
  pendingCount: number;
  series: ConsoleDashboardSeriesPointDto[];
  activity: ConsoleDashboardActivityDto[];
}

/**
 * Interim client for the v2 console dashboard endpoint.
 * Mirrors the base-path resolution of the generated api-client services.
 */
@Injectable({ providedIn: 'root' })
export class ConsoleDashboardV2Service {
  private readonly basePath: string;

  constructor(private http: HttpClient, apiConfig: AuthControllerService) {
    this.basePath = resolveApiBasePath(apiConfig);
  }

  /** Fetch the aggregated console dashboard for the last `days` days. */
  public getDashboard(days: number): Observable<ConsoleDashboardDto> {
    const params = new HttpParams().set('days', String(days));

    return this.http.get<ConsoleDashboardDto>(
      `${this.basePath}/api/v2/console/dashboard`,
      { params }
    );
  }
}
